<template>
    <div>
        <div class="tree gdheight mrt10" id="gdtree">
            <el-tree
                    ref="tree"
                    :data="treeData"
                    lazy
                    :load="loadNode"
                    :props="defaultProps"
                    node-key="i_id"
                    @node-click="handleNodeClick"
                    class="trees  video-tree height100"
                    accordion
                    :highlight-current='true'
                    :expand-on-click-node="false"
            >
                <!--      -->
                <!---->
            </el-tree>


        </div>
    </div>
</template>

<script>
    import * as API from ".././api.js"
    import {mapActions} from "vuex";

    export default {
        name: "leftTree",
        components: {},
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'vc_name',
                    isLeaf: 'isLeaf'
                },
                expanded:[],
                treeData:[],
            }
        },
        mounted() {
            let a={
                value:0,
                state:0
            }
            // this.getDeptTree(a)
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),

            async getDeptTree(a,resolve){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_pid:a.value,
                    i_state:a.state,
                };
                let res = await API.getDeptTree(param);
                if (res.code == 1) {
                    // let list=[];
                    if (res.data.length>0){
                        res.data.forEach(item=>{
                            this.$set(item,'isLeaf',item.haschild==0?true:false)
                            if(item.i_id!==0&&item.i_id!==-1){
                                this.$set(item,'vc_name',item.vc_name+'('+item.remainPerson+')')

                            }
                        })
                        if(a.value!==0){
                           return resolve(res.data)
                        }else{
                            this.treeData=res.data
                        }
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            handleNodeClick(val,node,e){
                if(val.i_state!==0||val.i_id==-1||val.i_id==0){
                    this.$emit('showData',val)
                }else{
                    this.$emit('getid',val)
                }
            },

            loadNode(node, resolve) {
                let _this=this;
                if (node.level === 0) {
                    let a={
                        value:0,
                        state:0
                    }
                        _this.getDeptTree(a,resolve);
                }
                if (node.level>=1&&node.data.haschild==1){
                    let a={
                        value:node.data.i_id,
                        state:node.data.i_state
                    }
                    _this.getDeptTree(a,resolve);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/.el-tree-node__label{
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>